<template>
  <div
    class="google-map mb-3"
    :class="{ 'd-none': item.displayOn && !display_none_check }"
  >
    <div class="">
      <div class="">
        <a
          class="float-right font-weight-medium mb-4 text-primary cursor-pointer"
          @click="resetBoundary"
          >Clear</a
        >
      </div>
    </div>
    <div class="map" ref="map"></div>
  </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";
export default {
  name: "create-google-map-boundary",
  props: {
    location: String,
    title: String,
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: Array,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      value: this.item_value,
      map: null,
      form: { postCode: "" },
      boundArray: [],
      google: null,
      mapShow: null,
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
    };
  },
  computed: {
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
  },
  watch: {
    selectedItem: {
      handler(val) {
        this.d_check = val ? val[this.item.displayOn] : false;
      },
      deep: true,
    },
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
      },
      deep: true,
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
    boundArray(val) {
      if (val.length > 0) {
        const createBoundary = new this.google.maps.Polygon({
          paths: val,
          strokeColor: "#005CE6",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#005CE0",
          fillOpacity: 0.35,
        });
        createBoundary.setMap(this.map);
      } else {
        this.map = new this.google.maps.Map(this.$refs.map, {
          zoom: 13,
          center: { lat: 51.43245889043812, lng: -0.7163955124507648 },
          mapTypeId: "terrain",
        });
      }
      this.updateValue(this.item_key, val);
    },
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
  },
  methods: {
    async initMap(reset = false) {
      let that = this;
      const loader = new Loader({
        apiKey: "AIzaSyBVSdzuQYpV9e6-7_mYah-Hw9eMJGvQQS4",
        libraries: ["places", "drawing"],
      });
      await loader.load();
      this.google = window.google;
      this.map = new this.google.maps.Map(this.$refs.map, {
        zoom: 13,
        // center: { lat: 21.2290505, lng: 72.899816 },
        center: { lat: 51.43245889043812, lng: -0.7163955124507648 },
        mapTypeId: "terrain",
      });

      const drawingManager = new this.google.maps.drawing.DrawingManager({
        drawingMode: null,
        drawingControl: true,
        drawingControlOptions: {
          position: this.google.maps.ControlPosition.TOP_CENTER,
          drawingModes: ["polygon"],
        },

        polygonOptions: {
          draggable: true,
          editable: true,
          fillOpacity: 0.5,
          strokeColor: "#005CE6",
        },
      });
      drawingManager.setMap(this.map);

      this.google.maps.event.addListener(
        drawingManager,
        "overlaycomplete",
        function (event) {
          event.overlay.set("editable", false);
          drawingManager.setMap(null);
          console.log(event.overlay);
        }
      );

      this.google.maps.event.addListener(
        drawingManager,
        "polygoncomplete",
        function (polygon) {
          // that.boundArray = [];
          var coordinates = polygon.getPath().getArray();
          for (let i = 0; i < coordinates.length; i++) {
            const temp = {
              lat: coordinates[i].lat(),
              lng: coordinates[i].lng(),
            };
            that.boundArray.push(temp);
          }
        }
      );

      if (!reset) this.boundArray = that.value;
    },
    resetBoundary() {
      this.boundArray = [];
      this.initMap(true);
    },
  },
  async mounted() {
    this.item.display = false;
    await this.initMap();
  },
};
</script>
<style lang="scss" scoped>
.google-map {
  // width: 100%;
  // margin-bottom: 60px;

  .map {
    width: 100%;
    height: 450px;
  }
  .map-view {
    h4 {
      font-size: 20px;
    }
  }
}
.base-form {
  background: transparent !important;
  box-shadow: none !important;

  .search-input {
    width: 400px;
  }
  .form-submit {
    width: 185px;
    background: #005eb8;
    color: #fff;
  }
  .reset-btn {
    width: 185px;
    background: #005eb8;
    color: #fff;
  }
}
</style>
